export default __webpack_public_path__ + "static/media/cloud-upload.cb6df37b.svg";